var map = {
	"./Anyswap.png": 55947,
	"./Anyswap.svg": 55152,
	"./Artwork.svg": 56287,
	"./Artwork_gmx.svg": 10641,
	"./Banxa.png": 15194,
	"./DROP_DOWN.svg": 18692,
	"./EQUAL.png": 82775,
	"./Hop.png": 79577,
	"./Hop.svg": 68415,
	"./Hop_dark.png": 20815,
	"./Hop_dark.svg": 45106,
	"./MMY-ETH.svg": 95523,
	"./MMY-FTM.svg": 27159,
	"./Squid.svg": 20138,
	"./Synapse.png": 3935,
	"./Synapse.svg": 73391,
	"./about.svg": 91403,
	"./account_overview.svg": 17759,
	"./account_overview_light.svg": 71418,
	"./aggregator/tokens/AAVE.png": 49594,
	"./aggregator/tokens/ANGEL.png": 81279,
	"./aggregator/tokens/ANY.png": 62191,
	"./aggregator/tokens/ATRI.webp": 48479,
	"./aggregator/tokens/BADGER.webp": 84186,
	"./aggregator/tokens/BAND.webp": 88038,
	"./aggregator/tokens/BEETS.png": 20782,
	"./aggregator/tokens/BIFI.webp": 12640,
	"./aggregator/tokens/BNB.webp": 96480,
	"./aggregator/tokens/BOMB.png": 45596,
	"./aggregator/tokens/BOO.png": 27914,
	"./aggregator/tokens/BOO.webp": 54137,
	"./aggregator/tokens/BRUSH.png": 91218,
	"./aggregator/tokens/CFi.png": 11375,
	"./aggregator/tokens/COFFIN.png": 78746,
	"./aggregator/tokens/COVER.png": 63973,
	"./aggregator/tokens/CREAM.webp": 14476,
	"./aggregator/tokens/CRV.webp": 46274,
	"./aggregator/tokens/CoUSD.png": 11361,
	"./aggregator/tokens/DAI.png": 82128,
	"./aggregator/tokens/DEATH.png": 29154,
	"./aggregator/tokens/DEUS.png": 96891,
	"./aggregator/tokens/DMD.png": 92231,
	"./aggregator/tokens/DOLA.png": 12810,
	"./aggregator/tokens/ELK.webp": 5486,
	"./aggregator/tokens/EXOD.png": 27023,
	"./aggregator/tokens/FANG.png": 97740,
	"./aggregator/tokens/FBOMB.webp": 75509,
	"./aggregator/tokens/FEED.png": 41278,
	"./aggregator/tokens/FHM.png": 28294,
	"./aggregator/tokens/FOO.png": 33188,
	"./aggregator/tokens/FRAX.png": 74030,
	"./aggregator/tokens/FS.png": 86625,
	"./aggregator/tokens/FTM.png": 8996,
	"./aggregator/tokens/FTMO.png": 20849,
	"./aggregator/tokens/FVM.png": 23820,
	"./aggregator/tokens/FXS.png": 84775,
	"./aggregator/tokens/GEIST.png": 19205,
	"./aggregator/tokens/GTON.png": 37546,
	"./aggregator/tokens/HEC.png": 79697,
	"./aggregator/tokens/HOB.png": 7586,
	"./aggregator/tokens/INV.png": 38881,
	"./aggregator/tokens/IronICE.png": 46385,
	"./aggregator/tokens/JuID.png": 21564,
	"./aggregator/tokens/KEK.png": 12774,
	"./aggregator/tokens/KNC.png": 79802,
	"./aggregator/tokens/LINK.webp": 57570,
	"./aggregator/tokens/LQDR.png": 51226,
	"./aggregator/tokens/LSHARE.png": 90116,
	"./aggregator/tokens/MAI.png": 2568,
	"./aggregator/tokens/MESO.png": 80674,
	"./aggregator/tokens/MIA.png": 33756,
	"./aggregator/tokens/MM.png": 55588,
	"./aggregator/tokens/MODA.png": 39028,
	"./aggregator/tokens/MPX.webp": 63105,
	"./aggregator/tokens/Metti.png": 37876,
	"./aggregator/tokens/Muttski.png": 99745,
	"./aggregator/tokens/PILLS.webp": 55061,
	"./aggregator/tokens/RIP.png": 92033,
	"./aggregator/tokens/SHADE.png": 56336,
	"./aggregator/tokens/SING.png": 36665,
	"./aggregator/tokens/SMART.png": 9290,
	"./aggregator/tokens/SOUL.png": 66934,
	"./aggregator/tokens/SPELL.png": 12418,
	"./aggregator/tokens/SPIRIT.png": 23421,
	"./aggregator/tokens/STEAK.png": 35925,
	"./aggregator/tokens/SUSHI.svg": 53707,
	"./aggregator/tokens/SYF.png": 36246,
	"./aggregator/tokens/TAROT.png": 83215,
	"./aggregator/tokens/TCS.png": 50742,
	"./aggregator/tokens/TOMB.png": 97268,
	"./aggregator/tokens/TRAVA.png": 76470,
	"./aggregator/tokens/TREEB.png": 18109,
	"./aggregator/tokens/TSHARE.webp": 56755,
	"./aggregator/tokens/TUSD.png": 52015,
	"./aggregator/tokens/UNIDX.jpeg": 11025,
	"./aggregator/tokens/Volta.png": 6803,
	"./aggregator/tokens/WOO.png": 28383,
	"./aggregator/tokens/WOOFY.png": 65977,
	"./aggregator/tokens/YEL.png": 27437,
	"./aggregator/tokens/YFI.webp": 54644,
	"./aggregator/tokens/ankrFTM.png": 12291,
	"./aggregator/tokens/atari.png": 69942,
	"./aggregator/tokens/badger.png": 68342,
	"./aggregator/tokens/band.png": 59035,
	"./aggregator/tokens/bay.png": 78698,
	"./aggregator/tokens/bepe.png": 97178,
	"./aggregator/tokens/bifi.png": 75164,
	"./aggregator/tokens/bnb.png": 32739,
	"./aggregator/tokens/btc.svg": 37360,
	"./aggregator/tokens/cream.png": 16400,
	"./aggregator/tokens/crv.png": 66370,
	"./aggregator/tokens/crvUSD.png": 24798,
	"./aggregator/tokens/d1.png": 23864,
	"./aggregator/tokens/dyor.png": 11918,
	"./aggregator/tokens/elk.png": 97732,
	"./aggregator/tokens/eth.png": 97904,
	"./aggregator/tokens/fONT.png": 26040,
	"./aggregator/tokens/fSWAMP.png": 9894,
	"./aggregator/tokens/fUSD.png": 75641,
	"./aggregator/tokens/fbomb.png": 64373,
	"./aggregator/tokens/frxETH.png": 27722,
	"./aggregator/tokens/gogo.png": 99520,
	"./aggregator/tokens/hype.png": 55477,
	"./aggregator/tokens/link.png": 83654,
	"./aggregator/tokens/mim.png": 2922,
	"./aggregator/tokens/mmy.svg": 28970,
	"./aggregator/tokens/mpx.png": 73791,
	"./aggregator/tokens/multiBTC.webp": 90007,
	"./aggregator/tokens/multiDAI.png": 77847,
	"./aggregator/tokens/pills.png": 70965,
	"./aggregator/tokens/scream.png": 55765,
	"./aggregator/tokens/sfrxETH.png": 47002,
	"./aggregator/tokens/sftmx.png": 84516,
	"./aggregator/tokens/speedy.png": 20980,
	"./aggregator/tokens/thruster.png": 16167,
	"./aggregator/tokens/token-default.svg": 46734,
	"./aggregator/tokens/tshare.png": 95080,
	"./aggregator/tokens/usdb.png": 34370,
	"./aggregator/tokens/usdc.svg": 23183,
	"./aggregator/tokens/usdt.svg": 90026,
	"./aggregator/tokens/wMEMO.png": 34740,
	"./aggregator/tokens/wbtc.svg": 2082,
	"./aggregator/tokens/weth.png": 24537,
	"./aggregator/tokens/weth.svg": 13172,
	"./aggregator/tokens/wftm.svg": 99942,
	"./aggregator/tokens/wigo.png": 98504,
	"./aggregator/tokens/xBOO.png": 12353,
	"./aggregator/tokens/yes.png": 71288,
	"./aggregator/tokens/yfi.png": 56354,
	"./aggregator/tokens/yoshi.png": 20258,
	"./analytic-v2.svg": 4477,
	"./analytic.svg": 93450,
	"./analytics/bg-header-v2.png": 54758,
	"./analytics/bg-header.png": 11856,
	"./analytics/bg.svg": 42173,
	"./analytics/contest.svg": 24563,
	"./analytics/fee.png": 29821,
	"./analytics/ic-pnl.svg": 52509,
	"./analytics/ic-search-wallet.svg": 48741,
	"./analytics/img-header-light.svg": 91825,
	"./analytics/img-header-v2.svg": 94773,
	"./analytics/img-header.svg": 41124,
	"./analytics/linked.png": 21167,
	"./analytics/mlpPool.svg": 78189,
	"./analytics/mlpPoolLight.svg": 40094,
	"./analytics/no-data-icon.svg": 87212,
	"./analytics/no-data-iconLight.svg": 5662,
	"./analytics/openInterest.svg": 57127,
	"./analytics/openInterestLight.svg": 83033,
	"./analytics/pattern-leader-board.svg": 16913,
	"./analytics/pool.png": 24163,
	"./analytics/realized-icon.svg": 71504,
	"./analytics/realizedIconLight.svg": 83602,
	"./analytics/right-img-leaderboard.png": 35781,
	"./analytics/right-img.svg": 28744,
	"./analytics/right_img-v2.svg": 59105,
	"./analytics/top-2-icon.svg": 4437,
	"./analytics/top-3-icon.svg": 47441,
	"./analytics/topPnL.svg": 80976,
	"./analytics/topPnLLight.svg": 24303,
	"./analytics/topVolume.svg": 72643,
	"./analytics/topVolumeLight.svg": 46269,
	"./analytics/totalFee.svg": 3757,
	"./analytics/totalFeeLight.svg": 79428,
	"./analytics/totalTradesV2.svg": 6899,
	"./analytics/totalTradesV2Light.svg": 92837,
	"./analytics/totalUser.svg": 90054,
	"./analytics/totalUserLight.svg": 75679,
	"./analytics/totalValueLogMSLP.svg": 1809,
	"./analytics/totalValueLogMSLPLight.svg": 52690,
	"./analytics/totalVolumn.png": 3854,
	"./analytics/totalVolumn.svg": 67554,
	"./analytics/totalVolumnLight.svg": 71486,
	"./analytics/user.png": 52600,
	"./analytics/v2/total_fee_paid.svg": 54045,
	"./analytics/v2/total_fee_paidLight.svg": 16125,
	"./analytics/v2/total_pnl.svg": 74173,
	"./analytics/v2/total_pnlLight.svg": 61101,
	"./analytics/v2/total_trading_volume.svg": 91987,
	"./analytics/v2/total_trading_volumeLight.svg": 78845,
	"./analytics/warning_icon.svg": 73907,
	"./arrow-route.svg": 37072,
	"./as_ref.svg": 29411,
	"./as_referrer_light.svg": 72097,
	"./as_trader.svg": 52782,
	"./as_trader_light.svg": 97670,
	"./backyellowicon.svg": 93702,
	"./binance.png": 66030,
	"./bitkeep.svg": 42267,
	"./blue-info.svg": 83859,
	"./blue_corner.svg": 63397,
	"./bridge.svg": 24232,
	"./bridge/Checkbox.svg": 48189,
	"./bridge/Checkbox_Checked.svg": 48689,
	"./bridge/bolt.svg": 16691,
	"./bridge/boltLight.svg": 98766,
	"./bridge/close.svg": 82325,
	"./bridge/empty.png": 80961,
	"./bridge/ic-plus.svg": 38614,
	"./bridge/ic-plusLight.svg": 8959,
	"./bridge/mmy.svg": 63870,
	"./bridge/new_checkbox.svg": 83605,
	"./bridge/new_checkboxLight.svg": 70134,
	"./bridge/new_checkbox_check.svg": 46788,
	"./bridge/new_checkbox_checkLight.svg": 26402,
	"./bridge/nft-item.svg": 11703,
	"./bridge/nft.svg": 81927,
	"./bridge_ic.svg": 56466,
	"./bscscan.png": 81128,
	"./btn_big_arbitrum.png": 70756,
	"./btn_big_avalanche.png": 11784,
	"./btn_big_bsc.png": 74872,
	"./btn_big_purchasegmx.png": 43760,
	"./btn_big_purchasegmx.svg": 12346,
	"./buy_gmx.svg": 59709,
	"./buy_gmx_bond.svg": 17868,
	"./buy_msp.svg": 80291,
	"./buy_transfer_eth.svg": 66961,
	"./chart-pad-light.svg": 6412,
	"./chart-pad-v2.svg": 46913,
	"./chart-placeholder.png": 97956,
	"./check_icon.svg": 9891,
	"./clock-bg.svg": 15023,
	"./coinbaseWallet.png": 32346,
	"./coingecko.png": 64993,
	"./coppy-light.svg": 19434,
	"./coppy.svg": 16233,
	"./copy.svg": 87823,
	"./cross.svg": 77150,
	"./dark_mode.svg": 13895,
	"./dark_modeLight.svg": 12396,
	"./dashboard/ftm.svg": 8110,
	"./dashboard/longPosition.svg": 79248,
	"./dashboard/longPositionLight.svg": 75429,
	"./dashboard/op.svg": 34727,
	"./dashboard/openInterest.svg": 97771,
	"./dashboard/pattern.svg": 28279,
	"./dashboard/shortPosition.svg": 51512,
	"./dashboard/shortPositionLight.svg": 42304,
	"./dashboard/since.svg": 96096,
	"./dashboard/sinceLight.svg": 30116,
	"./dashboard/tfee.svg": 5228,
	"./dashboard/tfeeLight.svg": 78515,
	"./dashboard/tuser.svg": 86107,
	"./dashboard/tvl.svg": 47726,
	"./dashboard/tvlLight.svg": 71573,
	"./dashboard/tvolumn.svg": 81920,
	"./dashboard/tvolumnLight.svg": 62052,
	"./default_avatar.svg": 10570,
	"./default_avatar_light.svg": 52359,
	"./dex/ageur.png": 47510,
	"./dex/arbi.png": 18994,
	"./dex/axlwmai.png": 18387,
	"./dex/balancer.png": 94175,
	"./dex/baldex.png": 15478,
	"./dex/base.png": 22387,
	"./dex/baseFinance.svg": 45238,
	"./dex/baso.png": 99408,
	"./dex/beethoven.png": 11463,
	"./dex/bombswap.png": 85754,
	"./dex/camelot.png": 73091,
	"./dex/chronos.png": 2362,
	"./dex/curve.png": 77174,
	"./dex/dackie.png": 14781,
	"./dex/default-dex.svg": 35979,
	"./dex/deus.png": 65743,
	"./dex/dodo.png": 87464,
	"./dex/e3.png": 30014,
	"./dex/equalizer.png": 80089,
	"./dex/equity.png": 28085,
	"./dex/excalibur.png": 70571,
	"./dex/firebird.png": 41770,
	"./dex/frax.png": 88056,
	"./dex/frxeth.png": 29097,
	"./dex/fusd.png": 82159,
	"./dex/gmx.png": 64717,
	"./dex/grai.png": 23760,
	"./dex/jetswap.png": 1723,
	"./dex/lif3.png": 99154,
	"./dex/mai.png": 33715,
	"./dex/mim.png": 87743,
	"./dex/morpheus.png": 91658,
	"./dex/morphex.png": 23127,
	"./dex/morphex.svg": 95782,
	"./dex/mummy.png": 64589,
	"./dex/opx.png": 63708,
	"./dex/paint.png": 45058,
	"./dex/partical.png": 28813,
	"./dex/protofi.png": 95867,
	"./dex/ramses.png": 30180,
	"./dex/rocket.png": 22870,
	"./dex/saddle.png": 65157,
	"./dex/seth.svg": 96296,
	"./dex/shekel.jpeg": 72537,
	"./dex/skeleton.png": 67740,
	"./dex/skull.png": 1428,
	"./dex/solidlizard.png": 56688,
	"./dex/solidly.png": 99552,
	"./dex/solidlyv3.png": 10819,
	"./dex/solunea.png": 74116,
	"./dex/soul.png": 89846,
	"./dex/spartacus.png": 63145,
	"./dex/spirit.png": 82717,
	"./dex/spooky.png": 60948,
	"./dex/sterling.png": 54575,
	"./dex/susd.png": 69834,
	"./dex/sushi.png": 60829,
	"./dex/swapbased.png": 55255,
	"./dex/synapse.png": 10314,
	"./dex/synth.png": 36658,
	"./dex/throne.png": 44134,
	"./dex/tomb.png": 47342,
	"./dex/traderjoe.png": 34828,
	"./dex/uniswap.png": 52837,
	"./dex/velocimeter.png": 48082,
	"./dex/velodrome.png": 80874,
	"./dex/voodoo.png": 86037,
	"./dex/wigo.png": 48019,
	"./dex/wombat.png": 70907,
	"./dex/woo.png": 43165,
	"./dex/wsteth.png": 89195,
	"./dex/xena.png": 52913,
	"./dex/yoshi.png": 59392,
	"./dex/zip.png": 19176,
	"./dex/zyber.png": 93655,
	"./downArrow.svg": 1137,
	"./downTriangleIc.svg": 10436,
	"./downTriangleIcLight.svg": 29955,
	"./earn/active_dot.svg": 34790,
	"./earn/active_dotLight.svg": 95665,
	"./earn/bg-light.png": 58616,
	"./earn/bg.svg": 56360,
	"./earn/check.svg": 10132,
	"./earn/esmmy_coin.svg": 85197,
	"./earn/lock.svg": 53857,
	"./earn/lockLight.svg": 90848,
	"./earn/mint_redeem.svg": 60285,
	"./earn/mlp_coin.svg": 53186,
	"./earn/mmy_coin.svg": 829,
	"./earn/overview.svg": 56265,
	"./earn/rewards.svg": 73475,
	"./earn/tab_mlp.svg": 2454,
	"./earn/tab_mmy.svg": 75546,
	"./earn/tab_transfer.svg": 60818,
	"./earn/tab_vault.svg": 67122,
	"./earn/tab_vest.svg": 59451,
	"./earn/vmmy_coin.svg": 33406,
	"./exchange-arrow-ic.svg": 49236,
	"./exchange-arrow-light-ic.svg": 82948,
	"./flag_en.svg": 49124,
	"./flag_es.svg": 95372,
	"./flag_fr.svg": 60839,
	"./flag_ja.svg": 44850,
	"./flag_ko.svg": 85160,
	"./flag_ru.svg": 76176,
	"./flag_zh.svg": 85896,
	"./frame_referrals.svg": 21241,
	"./frame_sticker.svg": 2255,
	"./frame_trading.svg": 32424,
	"./gateio.svg": 33610,
	"./glp_icon.svg": 3689,
	"./gmx-logo-final-white-small.png": 60860,
	"./gmx-logo-final-white.png": 17638,
	"./gmx-logo-final.png": 66289,
	"./gmx-logo-glow.png": 26844,
	"./gmx-logo-with-name.svg": 37058,
	"./gmx_logo.svg": 44368,
	"./graphite-01.png": 26020,
	"./gray_arrow.svg": 74632,
	"./gray_arrowLight.svg": 20083,
	"./green_corner.svg": 24193,
	"./header/about_light.svg": 70502,
	"./header/analytic-v2_light.svg": 95626,
	"./header/analytic_light.svg": 96857,
	"./header/arrow.svg": 73040,
	"./header/arrowLight.svg": 99004,
	"./header/bridge_ic_light.svg": 69293,
	"./header/bridge_light.svg": 47740,
	"./header/bridge_wormhole_light.svg": 13387,
	"./header/ic_copy_v2_16_light.svg": 68586,
	"./header/ic_new_link_v2_16_light.svg": 52290,
	"./header/ic_sign_out_v2_16_light.svg": 44301,
	"./header/leaderboard.svg": 99185,
	"./header/leaderboard_light.svg": 5574,
	"./header/legacy_light.svg": 83166,
	"./header/news_light.svg": 39370,
	"./header/perps_light.svg": 47948,
	"./header/poll_light.svg": 55301,
	"./header/referral_light.svg": 34803,
	"./header/skeleton_light.svg": 23596,
	"./header/swap_aggregator_ic_light.svg": 51209,
	"./header/swap_ic_light.svg": 942,
	"./header_ref.svg": 11645,
	"./home/1inch.svg": 27971,
	"./home/arbBackdrop.svg": 9554,
	"./home/arbBackdropLight.svg": 82713,
	"./home/background-v3.svg": 40815,
	"./home/banner-avt.png": 36671,
	"./home/banner-avt2.png": 5027,
	"./home/banner-bg-small-ip.png": 12156,
	"./home/banner-bg-small-ip2.png": 3022,
	"./home/banner-bg-small-mobile.png": 82000,
	"./home/banner-bg-small-mobile2.png": 10564,
	"./home/banner-bg-small.png": 34853,
	"./home/banner-bg-small2.png": 72375,
	"./home/banner-bg.png": 88447,
	"./home/banner-bg2.png": 53067,
	"./home/banner-vector.png": 14390,
	"./home/banner-vector2.png": 83503,
	"./home/bg.png": 57149,
	"./home/bg_nft.png": 70863,
	"./home/bg_nft_large.png": 12316,
	"./home/chain_pattern.svg": 38114,
	"./home/chainlink.svg": 726,
	"./home/chainlink_icon.svg": 82913,
	"./home/club1.svg": 51041,
	"./home/club2.svg": 16222,
	"./home/coinGecko.svg": 61852,
	"./home/coinMarketCap.svg": 11167,
	"./home/dappRadar.svg": 28103,
	"./home/deBank.svg": 36106,
	"./home/defiLlama.svg": 57037,
	"./home/dot-desc-ic.svg": 42630,
	"./home/equalizer.svg": 95211,
	"./home/fantom.svg": 45139,
	"./home/fireBird.svg": 71278,
	"./home/ftmBackdrop.svg": 74326,
	"./home/ftmBackdropLight.svg": 58459,
	"./home/home-banner-mobile.png": 45803,
	"./home/home-banner-mobile.svg": 25875,
	"./home/home-banner.png": 89346,
	"./home/home-banner.svg": 76201,
	"./home/home-content-img-1.svg": 61338,
	"./home/home-content-img-2.svg": 87770,
	"./home/home-content-img-3.svg": 81296,
	"./home/home-content-img-4.svg": 34041,
	"./home/ic-mint.svg": 63168,
	"./home/ic-mintLight.svg": 52097,
	"./home/ic-opensea.svg": 84979,
	"./home/ic_bnb.svg": 16144,
	"./home/ic_btc.svg": 8108,
	"./home/ic_custody.svg": 61015,
	"./home/ic_dai.svg": 68724,
	"./home/ic_eth.svg": 98381,
	"./home/ic_friendly.svg": 98498,
	"./home/ic_ftm.svg": 31080,
	"./home/ic_leveraged.svg": 42714,
	"./home/ic_lowFee.svg": 63132,
	"./home/ic_play.svg": 21553,
	"./home/ic_playLight.svg": 9614,
	"./home/ic_transprency.svg": 95484,
	"./home/ic_usdc.svg": 98163,
	"./home/ic_usdt.svg": 53027,
	"./home/ic_yeild.svg": 28723,
	"./home/kyberSwap.svg": 44530,
	"./home/landingpage-v3-bg.svg": 26646,
	"./home/layerZero.svg": 87527,
	"./home/lbBank.svg": 78105,
	"./home/line-left-to-right-mobile.svg": 6979,
	"./home/line-left-to-right.svg": 404,
	"./home/line-right-to-left-mobile.svg": 40108,
	"./home/line-right-to-left.svg": 79789,
	"./home/mexc.svg": 15526,
	"./home/mum1.png": 22985,
	"./home/mum2.png": 57883,
	"./home/mum3.png": 53350,
	"./home/mum4.png": 59603,
	"./home/mum5.png": 23873,
	"./home/nft1.png": 47630,
	"./home/nft2.png": 27981,
	"./home/odos.svg": 33920,
	"./home/opBackdrop.svg": 77055,
	"./home/openOcean.svg": 92631,
	"./home/optimize-right-img.svg": 30993,
	"./home/optimize.svg": 17710,
	"./home/pyth.svg": 54101,
	"./home/pyth_icon.svg": 87991,
	"./home/qSwap.svg": 6224,
	"./home/reduce.svg": 80823,
	"./home/saveCost.svg": 29313,
	"./home/spooky.svg": 90188,
	"./home/superiority-bg-mobile.svg": 32681,
	"./home/superiority-bg.svg": 67006,
	"./home/swap.svg": 9031,
	"./home/tokenTerminal.svg": 39285,
	"./home/totalFees.svg": 99672,
	"./home/totalTradingVolume.svg": 24727,
	"./home/totalUsers.svg": 37078,
	"./home/totalValueLocked.svg": 98655,
	"./home/velodrome.svg": 63601,
	"./home/verichain.svg": 66325,
	"./home/voyager.svg": 86484,
	"./home/wonderland.svg": 84074,
	"./ic-acc-fee-light.svg": 94397,
	"./ic-acc-fee.svg": 9814,
	"./ic-communityproject.svg": 78046,
	"./ic-pnl-light.svg": 16717,
	"./ic-pnl.svg": 38961,
	"./ic-view-arrow.svg": 1371,
	"./ic-view-arrowLight.svg": 16107,
	"./ic-view.svg": 67422,
	"./ic-volume-light.svg": 99921,
	"./ic-volume.svg": 86830,
	"./icARB.svg": 56106,
	"./icFantom.svg": 92444,
	"./icOP.svg": 71105,
	"./ic_1inch.svg": 67772,
	"./ic_account.svg": 28464,
	"./ic_across.svg": 13289,
	"./ic_ada_40.svg": 77143,
	"./ic_arb_24.svg": 56865,
	"./ic_arb_40.svg": 8270,
	"./ic_arbitrum_16.svg": 41898,
	"./ic_arbitrum_24.svg": 79762,
	"./ic_arbitrum_96.svg": 99060,
	"./ic_arbitrum_hover_16.svg": 48133,
	"./ic_arrow.svg": 15283,
	"./ic_arrowLight.svg": 65316,
	"./ic_arrowleft16.svg": 71774,
	"./ic_arrowright16.svg": 95143,
	"./ic_atom_40.svg": 54182,
	"./ic_aud_24.svg": 84746,
	"./ic_aud_40.svg": 66102,
	"./ic_avalanche_16.svg": 5412,
	"./ic_avalanche_24.svg": 84820,
	"./ic_avalanche_96.svg": 90742,
	"./ic_avax_24.svg": 90750,
	"./ic_avax_30.svg": 10506,
	"./ic_avax_40.svg": 22807,
	"./ic_axlbtc_24.svg": 15656,
	"./ic_axlbtc_40.svg": 41940,
	"./ic_axleth_24.svg": 1511,
	"./ic_axleth_40.svg": 7558,
	"./ic_axlusdc_24.svg": 35806,
	"./ic_axlusdc_40.svg": 80872,
	"./ic_axlusdt_24.svg": 99582,
	"./ic_axlusdt_40.svg": 3829,
	"./ic_bal_24.svg": 24,
	"./ic_bal_40.svg": 40997,
	"./ic_banxa.svg": 75136,
	"./ic_base_16.svg": 35051,
	"./ic_base_24.svg": 51390,
	"./ic_base_40.svg": 84665,
	"./ic_binance.svg": 57424,
	"./ic_binance_logo.svg": 85685,
	"./ic_bnb_16.svg": 2476,
	"./ic_bnb_24.svg": 74480,
	"./ic_bnb_40.svg": 44811,
	"./ic_bsc.svg": 47680,
	"./ic_bsc_96.svg": 65163,
	"./ic_btc.b_24.svg": 68279,
	"./ic_btc.b_40.svg": 91709,
	"./ic_btc_24.svg": 49351,
	"./ic_btc_40.svg": 80543,
	"./ic_btc_l0_24.svg": 84285,
	"./ic_btc_l0_40.svg": 80157,
	"./ic_bungee.png": 58595,
	"./ic_busd_24.svg": 99823,
	"./ic_buy_glp.svg": 9333,
	"./ic_buy_mlp.svg": 4419,
	"./ic_bybit.svg": 37557,
	"./ic_cad_24.svg": 34642,
	"./ic_cad_40.svg": 33668,
	"./ic_cash.png": 33795,
	"./ic_cash.svg": 42531,
	"./ic_cbeth_24.svg": 12506,
	"./ic_cbeth_40.svg": 70538,
	"./ic_checked.svg": 21019,
	"./ic_chf_24.svg": 30934,
	"./ic_chf_40.svg": 88277,
	"./ic_clock.svg": 68552,
	"./ic_clockLight.svg": 73063,
	"./ic_cny_24.svg": 43789,
	"./ic_cny_40.svg": 54332,
	"./ic_coinbase.svg": 81497,
	"./ic_coingecko_16.svg": 85613,
	"./ic_coingecko_hover_16.svg": 29277,
	"./ic_convert_down.svg": 34935,
	"./ic_copy.svg": 50238,
	"./ic_copy_16.svg": 15603,
	"./ic_copy_v2_16.svg": 21849,
	"./ic_cost.svg": 97906,
	"./ic_crv_24.svg": 66190,
	"./ic_crv_40.svg": 82883,
	"./ic_dai_24.svg": 86592,
	"./ic_dai_40.svg": 9641,
	"./ic_dai_l0_24.svg": 41699,
	"./ic_dai_l0_40.svg": 85518,
	"./ic_discord.svg": 21797,
	"./ic_discordLight.svg": 47674,
	"./ic_dodo.svg": 13394,
	"./ic_down_white.svg": 12718,
	"./ic_down_whiteLight.svg": 66551,
	"./ic_edit.svg": 92603,
	"./ic_email.svg": 50747,
	"./ic_equalizer.png": 33600,
	"./ic_eth_24.svg": 47639,
	"./ic_eth_40.svg": 78432,
	"./ic_eth_l0_24.svg": 83366,
	"./ic_eth_l0_40.svg": 90565,
	"./ic_eur_24.svg": 42600,
	"./ic_eur_40.svg": 75105,
	"./ic_fet_24.svg": 49662,
	"./ic_fet_40.svg": 53848,
	"./ic_firebird.png": 83041,
	"./ic_frax_24.svg": 5790,
	"./ic_frax_40.svg": 90630,
	"./ic_ftm_16.svg": 54674,
	"./ic_ftm_24.svg": 55245,
	"./ic_ftm_40.svg": 34286,
	"./ic_fxs_16.svg": 27189,
	"./ic_fxs_24.svg": 35378,
	"./ic_fxs_32.svg": 80162,
	"./ic_fxs_40.svg": 10347,
	"./ic_gbp_24.svg": 26336,
	"./ic_gbp_40.svg": 10637,
	"./ic_github.svg": 27467,
	"./ic_glp_24.svg": 98052,
	"./ic_glp_40.svg": 43798,
	"./ic_glp_custom.svg": 82842,
	"./ic_gmx.svg": 81790,
	"./ic_gmx_24.svg": 86268,
	"./ic_gmx_30.svg": 49772,
	"./ic_gmx_40.svg": 572,
	"./ic_gmx_64.svg": 36172,
	"./ic_gmx_arbitrum.svg": 75356,
	"./ic_gmx_avax.svg": 92967,
	"./ic_gmx_big.svg": 42876,
	"./ic_gmx_custom.svg": 55133,
	"./ic_gmx_footer.svg": 21986,
	"./ic_goog_40.svg": 10533,
	"./ic_hkd_24.svg": 6927,
	"./ic_hkd_40.svg": 90419,
	"./ic_hop.svg": 86934,
	"./ic_huobi.svg": 94052,
	"./ic_info.svg": 38628,
	"./ic_jpy_24.svg": 1053,
	"./ic_jpy_40.svg": 50863,
	"./ic_kucoin.svg": 9039,
	"./ic_kyber.svg": 65527,
	"./ic_language24.svg": 71085,
	"./ic_link_16.svg": 44856,
	"./ic_link_24.svg": 88956,
	"./ic_link_32.svg": 65680,
	"./ic_link_40.svg": 79529,
	"./ic_liquidity.svg": 76738,
	"./ic_ltc_40.svg": 48908,
	"./ic_matcha.png": 71243,
	"./ic_matic_40.svg": 94265,
	"./ic_medium.svg": 57488,
	"./ic_mediumLight.svg": 70856,
	"./ic_menu_dots.svg": 64337,
	"./ic_metamask_16.svg": 31356,
	"./ic_metamask_hover_16.svg": 68177,
	"./ic_mexc.png": 25288,
	"./ic_microswap.svg": 66970,
	"./ic_mim_24.svg": 95643,
	"./ic_mim_40.svg": 17928,
	"./ic_mkr_40.svg": 26348,
	"./ic_mlp_24.svg": 97984,
	"./ic_mlp_40.svg": 57777,
	"./ic_mlp_custom.svg": 26342,
	"./ic_mmy_24.svg": 61964,
	"./ic_mmy_30.svg": 24849,
	"./ic_mmy_40.svg": 36190,
	"./ic_mmy_64.svg": 18967,
	"./ic_mmy_custom.svg": 36387,
	"./ic_mmy_plh.png": 89336,
	"./ic_msft_40.svg": 45613,
	"./ic_msp-40.svg": 2775,
	"./ic_msp_40.svg": 84815,
	"./ic_multiswap.svg": 49215,
	"./ic_mxn_24.svg": 83011,
	"./ic_mxn_40.svg": 48144,
	"./ic_new_link_16.svg": 60613,
	"./ic_new_link_v2_16.svg": 30570,
	"./ic_noitemfound.svg": 42106,
	"./ic_noitemfound_light.svg": 87873,
	"./ic_nok_24.svg": 95793,
	"./ic_nok_40.svg": 96209,
	"./ic_not_24.svg": 23186,
	"./ic_not_40.svg": 32994,
	"./ic_nzd_24.svg": 603,
	"./ic_nzd_40.svg": 15077,
	"./ic_o3.png": 36666,
	"./ic_odos.png": 82284,
	"./ic_olympus.svg": 39219,
	"./ic_olympus_arbitrum.svg": 17682,
	"./ic_op_16.svg": 42742,
	"./ic_op_24.svg": 55605,
	"./ic_op_40.svg": 70711,
	"./ic_op_96.svg": 45908,
	"./ic_openocean.svg": 87132,
	"./ic_openoceanLight.svg": 4510,
	"./ic_ordi_24.svg": 80477,
	"./ic_ordi_40.svg": 15153,
	"./ic_paraswap.svg": 35071,
	"./ic_pepe_24.svg": 81595,
	"./ic_pepe_40.svg": 42905,
	"./ic_pyth_24.svg": 23254,
	"./ic_pyth_40.svg": 12712,
	"./ic_rdnt_24.svg": 88019,
	"./ic_rdnt_40.svg": 18527,
	"./ic_s_24.svg": 55952,
	"./ic_scan.svg": 60308,
	"./ic_scanLight.svg": 98965,
	"./ic_scan_white.svg": 76493,
	"./ic_scan_whiteLight.svg": 46288,
	"./ic_sek_40.svg": 43812,
	"./ic_selector_dropdowns.svg": 31370,
	"./ic_settings_16.svg": 88317,
	"./ic_settings_16_light.svg": 18641,
	"./ic_settings_24.svg": 94240,
	"./ic_sign in_16.svg": 37516,
	"./ic_sign_out_16.svg": 98741,
	"./ic_sign_out_v2_16.svg": 8893,
	"./ic_simpleswaps.svg": 50240,
	"./ic_skeleton.svg": 38291,
	"./ic_slingshot.svg": 93149,
	"./ic_snx_16.svg": 78779,
	"./ic_snx_24.svg": 90201,
	"./ic_snx_32.svg": 14024,
	"./ic_snx_40.svg": 82930,
	"./ic_sol_24.svg": 35575,
	"./ic_sol_40.svg": 27446,
	"./ic_spooky.svg": 55667,
	"./ic_spy_40.svg": 89458,
	"./ic_stats.svg": 98865,
	"./ic_stats_big.svg": 39236,
	"./ic_sui_24.svg": 53319,
	"./ic_sui_40.svg": 87364,
	"./ic_synapse.svg": 56993,
	"./ic_tbtc_24.svg": 38665,
	"./ic_tbtc_40.svg": 36780,
	"./ic_telegram.svg": 50933,
	"./ic_telegramLight.svg": 27162,
	"./ic_tether_24.svg": 8466,
	"./ic_tokens.svg": 12870,
	"./ic_ton_24.svg": 38900,
	"./ic_ton_40.svg": 33491,
	"./ic_totaluser.svg": 26141,
	"./ic_traderjoe.png": 81157,
	"./ic_trading.svg": 35095,
	"./ic_transfer_avax.svg": 54478,
	"./ic_twitter.svg": 16396,
	"./ic_twitterLight.svg": 46939,
	"./ic_twitterLightGreen.svg": 89015,
	"./ic_twitter_new.svg": 54238,
	"./ic_uni_24.svg": 61691,
	"./ic_uni_40.svg": 79812,
	"./ic_uni_arbitrum.svg": 78610,
	"./ic_usd+_24.svg": 33163,
	"./ic_usd+_40.svg": 93436,
	"./ic_usdbc_24.svg": 12051,
	"./ic_usdbc_40.svg": 9208,
	"./ic_usdc.e_24.svg": 40890,
	"./ic_usdc.e_40.svg": 14206,
	"./ic_usdc_24.svg": 8038,
	"./ic_usdc_40.svg": 1924,
	"./ic_usdc_l0_24.svg": 25498,
	"./ic_usdc_l0_40.svg": 38207,
	"./ic_usdt_24.svg": 17039,
	"./ic_usdt_40.svg": 59757,
	"./ic_usdt_l0_24.svg": 30266,
	"./ic_usdt_l0_40.svg": 17426,
	"./ic_velodrome.svg": 211,
	"./ic_wallet_24.svg": 75395,
	"./ic_waring.svg": 27495,
	"./ic_wavax_24.svg": 62690,
	"./ic_wavax_40.svg": 29994,
	"./ic_wbtc_24.svg": 93205,
	"./ic_wbtc_40.svg": 50195,
	"./ic_weth_24.svg": 9151,
	"./ic_weth_40.svg": 8521,
	"./ic_wftm_16.svg": 26514,
	"./ic_wftm_24.svg": 78139,
	"./ic_wftm_40.svg": 58679,
	"./ic_xag_24.svg": 14323,
	"./ic_xag_40.svg": 82907,
	"./ic_xau_24.svg": 97548,
	"./ic_xau_40.svg": 93685,
	"./ic_xrp_24.svg": 17387,
	"./ic_xrp_40.svg": 94138,
	"./ic_yield_yak.png": 81411,
	"./ic_zar_40.svg": 35514,
	"./icon_vest.svg": 93887,
	"./icon_vestLight.svg": 15716,
	"./icons/Checkbox--inactive.svg": 98595,
	"./icons/Checkbox--inactiveLight.svg": 28757,
	"./icons/Checkbox.svg": 83620,
	"./icons/CheckboxLight.svg": 22502,
	"./icons/MMY.svg": 57171,
	"./icons/alert.svg": 25668,
	"./icons/arrow_down.svg": 8901,
	"./icons/bridge.svg": 94909,
	"./icons/chart-pad.svg": 64144,
	"./icons/checkbox-ic.svg": 97455,
	"./icons/checkbox-ic1.svg": 78349,
	"./icons/checkbox-ic1Light.svg": 71505,
	"./icons/checkbox-icLight.svg": 80863,
	"./icons/copy-ic.svg": 76892,
	"./icons/copy-icLight.svg": 88877,
	"./icons/discord.svg": 30297,
	"./icons/download-ic.svg": 15711,
	"./icons/download-icLight.svg": 68418,
	"./icons/dropdown-ic-header.svg": 77257,
	"./icons/dropdown-ic.svg": 1609,
	"./icons/flash.svg": 12817,
	"./icons/github.svg": 39787,
	"./icons/ic-info.svg": 8984,
	"./icons/ic-infoLight.svg": 80789,
	"./icons/ic-prev.svg": 2770,
	"./icons/ic_binance.svg": 35629,
	"./icons/ic_bitfinex.svg": 22520,
	"./icons/ic_bybit.svg": 24153,
	"./icons/ic_coinbase.svg": 5565,
	"./icons/ic_crypto.svg": 24479,
	"./icons/ic_kucoin.svg": 69707,
	"./icons/ic_median.svg": 3452,
	"./icons/ic_msp.svg": 22911,
	"./icons/ic_nlp.svg": 53416,
	"./icons/ic_okx.svg": 2428,
	"./icons/icon-up.svg": 43450,
	"./icons/link-green.svg": 61457,
	"./icons/link-greenLight.svg": 12798,
	"./icons/link-white.svg": 18522,
	"./icons/link.svg": 17595,
	"./icons/linkLight.svg": 4533,
	"./icons/medium.svg": 82422,
	"./icons/mm-usd.svg": 45083,
	"./icons/redirect-green.svg": 57581,
	"./icons/redirect-greenLight.svg": 29686,
	"./icons/redirect.svg": 80048,
	"./icons/redirectLight.svg": 67315,
	"./icons/search.svg": 43344,
	"./icons/short_right.svg": 92049,
	"./icons/telegram.svg": 82718,
	"./icons/treasury.svg": 8194,
	"./icons/tweet-ic.svg": 67345,
	"./icons/tweet-icLight.svg": 3702,
	"./icons/twitter.svg": 46138,
	"./launch": 76971,
	"./launch/": 76971,
	"./launch/Ic_redRectangle.svg": 46508,
	"./launch/Ic_yellowRectangle.svg": 88205,
	"./launch/clockIcon": 5224,
	"./launch/clockIcon.tsx": 5224,
	"./launch/copyIcon": 59417,
	"./launch/copyIcon.tsx": 59417,
	"./launch/ic-plus.svg": 26817,
	"./launch/ic_clock.svg": 31195,
	"./launch/ic_complete.svg": 52614,
	"./launch/ic_deposit.svg": 69368,
	"./launch/ic_inprogress.svg": 43407,
	"./launch/ic_trade.svg": 37766,
	"./launch/icon1": 73609,
	"./launch/icon1.tsx": 73609,
	"./launch/icon2": 6361,
	"./launch/icon2.tsx": 6361,
	"./launch/icon3": 46503,
	"./launch/icon3.tsx": 46503,
	"./launch/icon4": 78690,
	"./launch/icon4.tsx": 78690,
	"./launch/iconArrow": 57906,
	"./launch/iconArrow.tsx": 57906,
	"./launch/iconStatus.svg": 5622,
	"./launch/index": 76971,
	"./launch/index.ts": 76971,
	"./layer0.svg": 23998,
	"./layer0Light.svg": 38328,
	"./left_arrow.svg": 11213,
	"./left_arrowLight.svg": 67930,
	"./legacy.svg": 70555,
	"./lg_arbitrum.svg": 96276,
	"./lifi.png": 11944,
	"./light/ic_axleth_24.svg": 33918,
	"./light/ic_axleth_40.svg": 27764,
	"./light/ic_eth_24.svg": 13279,
	"./light/ic_eth_40.svg": 35635,
	"./light/ic_sol_24.svg": 29296,
	"./light/ic_sol_40.svg": 65402,
	"./light_mode.svg": 97832,
	"./light_modeLight.svg": 68425,
	"./lock/img_right.svg": 71530,
	"./lock/img_rightLight.svg": 20638,
	"./logo_GMX.svg": 20334,
	"./logo_GMX_small.svg": 19156,
	"./logo_MMY.svg": 34709,
	"./logo_MMY_small.svg": 56476,
	"./logo_MMY_smallLight.svg": 80711,
	"./logo_MMY_v2.svg": 51344,
	"./logo_MMY_v2_light.svg": 29501,
	"./long.svg": 54905,
	"./metamask-text.svg": 78232,
	"./metamask.png": 46521,
	"./metamask.svg": 97134,
	"./microswap/logo-black.svg": 58548,
	"./microswap/logo-white.svg": 52777,
	"./mlp_coin.svg": 83771,
	"./mmy_coin.svg": 16118,
	"./mmy_ftm_coin.svg": 67741,
	"./mslp_coin.svg": 25968,
	"./news.svg": 36480,
	"./page-not-found.svg": 39014,
	"./parrten.svg": 90275,
	"./perps.svg": 86227,
	"./poll.svg": 1074,
	"./portfolio/profitLoss.svg": 3715,
	"./portfolio/profitLossLight.svg": 29673,
	"./portfolio/ranking.svg": 65093,
	"./portfolio/rankingLight.svg": 57362,
	"./portfolio/trade.svg": 38028,
	"./portfolio/tradeLight.svg": 98195,
	"./portfolio/volume.svg": 81065,
	"./portfolio/volumeLight.svg": 23661,
	"./position-share-bg.png": 59430,
	"./profit-light.svg": 97540,
	"./purple_corner.svg": 74576,
	"./radio-checked-light.svg": 41568,
	"./radio-checked.svg": 92849,
	"./radio-unchecked-light.svg": 57678,
	"./radio-unchecked.svg": 42417,
	"./rango.png": 97607,
	"./ranking-light.svg": 83838,
	"./ref_header_cash.svg": 35159,
	"./referral.svg": 33606,
	"./reload.svg": 38037,
	"./risk-high.svg": 32820,
	"./risk-low.svg": 37084,
	"./risk-medium.svg": 42720,
	"./routerTab/mlp.svg": 31424,
	"./routerTab/mlpLight.svg": 529,
	"./routerTab/mmy_esmmy.svg": 3334,
	"./routerTab/mmy_esmmyLight.svg": 41478,
	"./routerTab/msp.svg": 40645,
	"./routerTab/mspLight.svg": 26784,
	"./routerTab/overview.svg": 36379,
	"./routerTab/overviewLight.svg": 23165,
	"./routerTab/transfer_account.svg": 89315,
	"./routerTab/transfer_accountLight.svg": 48538,
	"./routerTab/vault.svg": 40668,
	"./routerTab/vest.svg": 58945,
	"./routerTab/vestLight.svg": 74915,
	"./rpc-status-high-light.svg": 39971,
	"./rpc-status-high.svg": 3946,
	"./rpc-status-low-light.svg": 23348,
	"./rpc-status-low.svg": 59386,
	"./rpc-status-medium-light.svg": 2017,
	"./rpc-status-medium.svg": 8031,
	"./share.svg": 42574,
	"./shareGray.svg": 81552,
	"./shareLight.svg": 93520,
	"./short.svg": 28800,
	"./skeleton.svg": 43520,
	"./socket-teck.jpeg": 3247,
	"./swap.svg": 1630,
	"./swap_aggregator_ic.svg": 92309,
	"./swap_ic.svg": 82856,
	"./toast-error-ic.svg": 24834,
	"./toast-info-ic.svg": 94379,
	"./toast-sucsess-ic.svg": 10229,
	"./toast-warn-ic.svg": 29398,
	"./tokens.svg": 79900,
	"./tokens/eth.svg": 53069,
	"./tokens/ftm.svg": 88994,
	"./tooltip.svg": 18070,
	"./top1.svg": 34390,
	"./top2.svg": 97445,
	"./top2Light.svg": 77835,
	"./top3.svg": 71441,
	"./top3Light.svg": 38122,
	"./trade-light.svg": 70163,
	"./trade/add_positon.svg": 95765,
	"./trade/add_tp.svg": 40917,
	"./trade/add_trailing.svg": 13273,
	"./trade/arrow-down-green.svg": 8818,
	"./trade/arrow-down-red.svg": 61798,
	"./trade/arrow-down.svg": 95030,
	"./trade/arrow-downLight.svg": 43897,
	"./trade/arrow-green-light.svg": 23949,
	"./trade/arrow-green.svg": 1322,
	"./trade/chains.svg": 85989,
	"./trade/chains_light.svg": 1933,
	"./trade/color_bg.png": 87576,
	"./trade/copy.svg": 21462,
	"./trade/copyDisabled.svg": 42018,
	"./trade/download.svg": 25724,
	"./trade/downloadDisabled.svg": 98298,
	"./trade/edit.svg": 93449,
	"./trade/high-risk-light.svg": 23527,
	"./trade/high-risk.svg": 58551,
	"./trade/increase_collateral.svg": 63072,
	"./trade/increase_leverge.svg": 44935,
	"./trade/long-light.svg": 22930,
	"./trade/low-risk-light.svg": 9225,
	"./trade/low-risk.svg": 22001,
	"./trade/medium-risk-light.svg": 93356,
	"./trade/medium-risk.svg": 3297,
	"./trade/new_tab.svg": 58305,
	"./trade/nine-dots.svg": 97476,
	"./trade/other-token-icon-light.svg": 96074,
	"./trade/other-token-icon.svg": 87431,
	"./trade/share.svg": 58971,
	"./trade/share_position.png": 34742,
	"./trade/share_position_v2.png": 76660,
	"./trade/short-light.svg": 9992,
	"./trade/star.svg": 1493,
	"./trade/swap_icon.svg": 61962,
	"./trade/tweet.svg": 51229,
	"./trade/tweetDisabled.svg": 40492,
	"./trade/write-link-icon.svg": 53125,
	"./trading.jpg": 30393,
	"./triangle.svg": 75067,
	"./triangleLight.svg": 42990,
	"./twitter.svg": 8906,
	"./upArrow.svg": 61924,
	"./upArrowWhite.svg": 68497,
	"./volume-light.svg": 42634,
	"./vote/icon.svg": 90939,
	"./vote/item-icon.svg": 96625,
	"./wallet-connect-text.svg": 51812,
	"./walletconnect-circle-blue.svg": 68891,
	"./wave-01.png": 49338,
	"./wave-02.png": 55046,
	"./wrong-network.svg": 44060,
	"./wrong-networkLight.svg": 75273,
	"./xy.svg": 42666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51327;